export const checkPromotion = (promotion) => (promotion ? promotion : 'sin promoción');
